export default __webpack_public_path__ + "static/media/(3).49662b23.jpeg";